// extracted by mini-css-extract-plugin
module.exports = {"basic-message":"basic-message-a003139b7122b81a1c98c8e8e96f21bf"};